import MegaMenuItem from './MegaMenuItem';

export default MegaMenuItem;
